let obj = {};
window.localStorage.setItem('DZ_TYPE', process.env.DZ_TYPE);
switch (process.env.DZ_TYPE) {
    case 'PUTI':
        //菩提
        obj.kefuImage = 'https://oss.fjdaze.com/oneKeyCopy1688/common/wxkf-puti.jpg';
        obj.baseTitle = '菩提';
        obj.serverPhone = '177 5918 6539';
        obj.appKey = '7225886893387286020';
        obj.platformId = 3;
        obj.localToken = 'tiktokweb8a7a292bde454675a4c4304';
        obj.indexAdPageId = '511e456a14b482dd52eb8a95016def23';
        obj.userServiceAgreementUrl = 'https://fzputi.com/userServiceAgreement.html';
        obj.appService = 1;
        obj.tutorialUrl = 'https://support.qq.com/products/513438/faqs/145926';
        break;
    default:
        //大泽
        obj.kefuImage = 'https://oss.fjdaze.com/oneKeyCopy1688/common/wxkf.jpg';
        obj.baseTitle = '大泽';
        obj.serverPhone = '170 5203 0091';
        obj.appKey = '6840999917110199815';
        obj.platformId = 3;
        // 抖店 tiktokweb8a7a292bde454675a4c4304  云鸽 tiktokkua31ece49810fc4d6f9d8b284;  茶 tiktokweb9a41641c01c14b54a8c09a4 SYQ tiktokweb4e4f61d0625d496aad1c0e1
        obj.localToken = 'tiktokweb8a7a292bde454675a4c4304';
        obj.indexAdPageId = 'e473ff40c74cd90d4cc19f1b5ee92109';
        obj.userServiceAgreementUrl = 'https://help.fjdaze.com/userServiceAgreement.html';
        obj.appService = 0;
        obj.tutorialUrl = 'https://support.qq.com/products/465306/faqs/145127';
}
export const kefuImage = obj.kefuImage;
export const baseTitle = obj.baseTitle;
export const baseType = process.env.DZ_TYPE || 'DAZE';
export const serverPhone = obj.serverPhone;
export const appKey = obj.appKey;
export const appService = obj.appService;
export const platformId = obj.platformId;
export const localToken = obj.localToken;
export const indexAdPageId = obj.indexAdPageId;
export const tutorialUrl = obj.tutorialUrl;
export const userServiceAgreementUrl = obj.userServiceAgreementUrl;
